import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Modal } from "../Modal";
import { ConfirmModalActions } from "./ConfirmModalActions";

const useStyles = makeStyles({
  text: {
    fontSize: "16px",
    lineHeight: "20px",
    marginTop: "10px",
  },
});

export const ConfirmModal = ({ open, title, content, onClose, onContinue }) => {
  const styles = useStyles();

  const closeClick = () => onClose && onClose();

  const continueClick = () => {
    onContinue && onContinue();
    closeClick();
  };

  return (
    <Modal
      maxWidth={"xs"}
      open={open}
      onClose={closeClick}
      title={title || ""}
      content={
        <>
          <Typography className={styles.text}>{content || ""}</Typography>
        </>
      }
      actions={
        <ConfirmModalActions onCancel={closeClick} onContinue={continueClick} />
      }
      minWidth={480}
    />
  );
};
